import { Group, Text } from "@mantine/core";
import { DataGridPage, EntityClientAction } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { SolicitudesRuteoImportacionProceso } from "./SolicitudesRuteoImportacionProceso/SolicitudesRuteoImportacionProceso";

export const ACTVerImportaciones: EntityClientAction = {
    name: 'ACTVerImportaciones',
    label: 'Ver Importaciones',
    title: <Text fw={700}>Ver Importaciones</Text>,
    refreshOnClose: true,
    dontRequireSelection: true,
    views: ['soru_brwDisponibleEnRutas'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const solicitudesRuteoImportacionProceso = new SolicitudesRuteoImportacionProceso(entity.API.client);

        await modal.open({
            modalProps: {
                title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">Importaciones de Ruteos</Text></Group>,
                size: "xl"
            },
            focusOnClosed: element,
            content: <DataGridPage
                key="importaciones-solicitudes-ruteo"
                client={entity.API.client}
                entityConstructor={() => solicitudesRuteoImportacionProceso}
                formMode="edit"
                viewName="srip_brwStandard"
                refreshOnInit
                enableAdd={false}
                enableDelete={false}
                enableEdit={false}
                enableView={true}
                title="Ver Importaciones de Ruteos"
                selectionMode="single" />
        });

        return false;
    }
}